import { api, type PostItem, type RevealRequest } from '@/lib/api';

// Two GET endpoints (`/me/reveal-requests`, `/threads/{id}/posts`) used
// to return the complete list; issue #137/#138's keyset pagination
// (20-row default page size) capped each of them at its first page.
// Their consumers -- profile-view's single-pair scan, the
// reveal-requests screen's four-bucket split, the incoming-count hook,
// and thread-detail's reply list -- all assumed the complete list, so
// silently truncating them broke real behavior (an older pending
// reveal request could vanish from every surface that shows it). These
// helpers restore that pre-pagination behavior by looping through every
// cursor page client-side, mirroring how backend/internal/http/me.go's
// ExportMeHandler already loops server-side until NextCursor is
// exhausted -- same pattern, just in TypeScript. None of this adds
// infinite-scroll UI; it's an internal loop that hands callers a flat
// array, same as before this branch.
//
// (/me/connections used to have a fetchAllConnections here too; its
// consumers now read the single paginated cache through
// hooks/use-connections.ts's useAllConnections instead.)

export async function fetchAllRevealRequests(): Promise<RevealRequest[]> {
  const all: RevealRequest[] = [];
  let cursor: string | undefined;

  for (;;) {
    const page = await api.listMyRevealRequests(cursor);
    all.push(...page.items);
    if (!page.nextCursor) break;
    cursor = page.nextCursor;
  }

  return all;
}

export async function fetchAllPosts(threadId: string): Promise<PostItem[]> {
  const all: PostItem[] = [];
  let cursor: string | undefined;

  for (;;) {
    const page = await api.listPosts(threadId, cursor);
    all.push(...page.items);
    if (!page.nextCursor) break;
    cursor = page.nextCursor;
  }

  return all;
}
